import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import { upperMenuHeight } from "../../../../common/parameters";

export const UpperMenu = styled.div`
    height: ${upperMenuHeight}px;
    position: fixed;
    background-color: ${p => p.theme.c.boost};
    top: 0;
    left: 0;
    right: 0;
    color: ${p => p.theme.c.snowOnActive};
    line-height: 30px;
    display: flex;
    align-items: center;
    z-index: 2;
    box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow3};
    ${p => p.theme.withNotch(css`
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
    `)}

    button {
        background-color: transparent;
        outline: none;
        border: none;
    }
`;

const MenuSide = styled.div`
    flex: 1;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .arrow-back {
        width: 32px;
        height: 32px;
        display: block;
    }
`;

export const MenuLeft = styled(MenuSide)`
    ${p =>
        p.theme.xs(css`
            flex: none;
        `)}
`;

export const ArrowButton = styled.button`
    padding: 0 10px;
    z-index: 100;
    cursor: pointer;
    height: 50px;
    ${p =>
        p.theme.xs(css`
            padding: 0 6px;
        `)}
    .i-arrowback {
        color: ${p => p.theme.c.whiteOnActive};
        position: relative;
        top: 1px;
        font-size: 36px;
    }

    &.Flip {
        .i-arrowback {
            transform: scale(-1, 1);
            display: inline-block;
        }
    }

    &.Inactive {
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
    }
`;

export const Logo = styled(Link)`
    margin-left: 6px;
    color: ${p => p.theme.c.snowOnActive};
    display: flex;
    align-items: center;
    transition: 400ms;
    left: calc((100vw - 188px) / 2);
    position: fixed;
    svg {
        fill: ${p => p.theme.c.whiteOnActive};
    }
`;
